<!--緊急連絡先申請-->
<template>
  <div>
    <!-- 基本情報 -->
    <div style="margin-top:5px">
      <!-- 表头文字 -->
      <el-row :gutter="0" style="background-color:#3cc6fa;">
        <div class="table-header">{{$t('MODULE.I0004_LBL_TITLE')}}</div>
      </el-row>
      <table class="i0004-table table-label">
        <!-- 郵便番号 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_POSTCODE')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" style="width:55px" maxlength="3" v-model="ecPostCd1" :readonly="false" @input="ecPostCd1 = ecPostCd1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0004-input" style="width:65px" maxlength="4" v-model="ecPostCd2" :readonly="false" @input="ecPostCd2 = ecPostCd2.replace(/[^\d]/g, '');"></el-input>
            <!---住所取得ボタン -->
            <el-button class="i0004-css-addressbtn" @click="address_click">{{$t('MODULE.I0004_LBL_GETHOME')}}</el-button><span style="color:red;">＊</span>
          </td>
        </tr>
        <!-- 住所 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_HOME')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" v-model="ecAddress1"></el-input><span style="color:red">＊</span>
            <el-input class="i0004-input" style="margin-top:3px" v-model="ecAddress2"></el-input>
            <el-input class="i0004-input" style="margin-top:3px" v-model="ecAddress3"></el-input>
          </td>
        </tr>
        <!-- 携帯番号 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_CARRYCODE')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" style="width:64px" v-model="ecMobileNo1" pattern="\d*" maxlength="4" @input="ecMobileNo1 = ecMobileNo1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0004-input" style="width:64px" v-model="ecMobileNo2" pattern="\d*" maxlength="4" @input="ecMobileNo2 = ecMobileNo2.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0004-input" style="width:64px" v-model="ecMobileNo3" pattern="\d*" maxlength="4" @input="ecMobileNo3 = ecMobileNo3.replace(/[^\d]/g, '');"></el-input>
          </td>
        </tr>
        <!-- 電話番号 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_TELCODE')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" style="width:64px" v-model="ecPhoneNo1" pattern="\d*" maxlength="4" @input="ecPhoneNo1 = ecPhoneNo1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0004-input" style="width:64px" v-model="ecPhoneNo2" pattern="\d*" maxlength="4" @input="ecPhoneNo2 = ecPhoneNo2.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0004-input" style="width:64px" v-model="ecPhoneNo3" pattern="\d*" maxlength="4" @input="ecPhoneNo3 = ecPhoneNo3.replace(/[^\d]/g, '');"></el-input>
          </td>
        </tr>
        <!-- 連絡先名 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_CALLNAME')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" maxlength="100" v-model="ecName"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
        <!-- 続柄 -->
        <tr>
          <td class="i0004-form-label">{{$t('MODULE.I0004_LBL_RELAT')}}</td>
          <td class="i0004-form-value">
            <el-input class="i0004-input" maxlength="20" v-model="ecRelations"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
      </table>
      <!--申請中-->
      <span style="font-size: 10pt;" v-if="this.processCd == 1">{{this.statusName}}&nbsp;{{this.timeShow}}</span>
      <!-- 申请按钮 -->
      <div style="text-align:center">
        <el-button class="i0004-css-btn" @click="apply_click">{{$t('MODULE.I0004_LBL_APPLY')}}</el-button>
      </div>
    </div>
    <div>
      <DialogAddress :visible.sync="showAddressDialog" v-if="showAddressDialog" :show="showAddressDialog" :mainpostcode="addressPostCode" @closeAddressDialog="closeAddressDialog" @submitAddressDialog="submitAddressDialog"></DialogAddress>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0004"
import css from "@/statics/css"
import DialogAddress from '@/components/page/dialogAddress'
import utils from '../../common/utils'
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  components: {
    "DialogAddress": DialogAddress,
  },
  data() {
    return {
      //郵便番号
      ecPostCd1: "",
      ecPostCd2: "",
      //住所1
      ecAddress1: "",
      //住所2
      ecAddress2: "",
      //住所3
      ecAddress3: "",
      //携帯番号
      ecMobileNo1: "",
      ecMobileNo2: "",
      ecMobileNo3: "",
      //電話番号
      ecPhoneNo1: "",
      ecPhoneNo2: "",
      ecPhoneNo3: "",
      //連絡先名
      ecName: "",
      //続柄
      ecRelations: "",
      //申請日時
      applyDate: "",
      //申請ステータス
      status: "",
      //ステータス名
      statusName: "",
      //申請番号
      id: "",
      //処理区分
      processCd: "",
      //確認日時
      confirmDate: "",
      //更新日時
      updateDate: "",
      //日時表示
      timeShow: "",
      userCd: "",
      showAddressDialog: false,
      //郵便番号(住所取得ボタン用)
      addressPostCode: ""
    }
  },
  created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;

    //検索
    this.query();

  },
  methods: {
    // 検索
    query() {
      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 検索処理
      amsApi.i_0004_query(this.userCd).then(res => {
        if (res.code == 204) {
          if (res.items.selfDoc[0].ecPostCd == null) {
            this.ecPostCd1 = "";
            this.ecPostCd2 = "";
          } else {
            this.ecPostCd1 = res.items.selfDoc[0].ecPostCd.split("-")[0];
            this.ecPostCd2 = res.items.selfDoc[0].ecPostCd.split("-")[1];
          }

          this.ecAddress1 = res.items.selfDoc[0].ecAddress1;
          this.ecAddress2 = res.items.selfDoc[0].ecAddress2;
          this.ecAddress3 = res.items.selfDoc[0].ecAddress3;

          if (res.items.selfDoc[0].ecMobileNo == null) {
            this.ecMobileNo1 = "";
            this.ecMobileNo2 = "";
            this.ecMobileNo3 = "";
          } else {
            this.ecMobileNo1 = res.items.selfDoc[0].ecMobileNo.split("-")[0];
            this.ecMobileNo2 = res.items.selfDoc[0].ecMobileNo.split("-")[1];
            this.ecMobileNo3 = res.items.selfDoc[0].ecMobileNo.split("-")[2];
          }

          if (res.items.selfDoc[0].ecPhoneNo == null) {
            this.ecPhoneNo1 = "";
            this.ecPhoneNo2 = "";
            this.ecPhoneNo3 = "";
          } else {
            this.ecPhoneNo1 = res.items.selfDoc[0].ecPhoneNo.split("-")[0];
            this.ecPhoneNo2 = res.items.selfDoc[0].ecPhoneNo.split("-")[1];
            this.ecPhoneNo3 = res.items.selfDoc[0].ecPhoneNo.split("-")[2];
          }

          this.ecName = res.items.selfDoc[0].ecName;
          this.ecRelations = res.items.selfDoc[0].ecRelations;

          this.applyDate = res.items.selfDoc[0].applyDate;
          if (res.items.selfDoc[0].id == null) {
            this.id = 0;
          } else {
            this.id = res.items.selfDoc[0].id;
          }

          this.processCd = res.items.selfDoc[0].processCd;

          this.status = res.items.selfDoc[0].status;
          this.statusName = res.items.selfDoc[0].statusName;
          this.confirmDate = res.items.selfDoc[0].confirmDate;
          this.updateDate = res.items.selfDoc[0].updateDate;

          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (this.processCd == "1") {
            if (this.status == "0") {
              this.timeShow = utils.extractMillisecond(this.applyDate);
            } else if (this.status == "1" || this.status == "2") {
              this.timeShow = utils.extractMillisecond(this.confirmDate);
            }
          }

        } else if (res.code === 300) {
          this.loading.close();
          return
        }
        this.loading.close();
      }).catch(() => {
        this.loading.close();
      });
    },
    // 申请
    apply_click() {

      if (this.ecPostCd1 == null) {
        this.ecPostCd1 = ""
      }
      if (this.ecPostCd2 == null) {
        this.ecPostCd2 = ""
      }
      if (this.ecAddress1 == null) {
        this.ecAddress1 = ""
      }
      if (this.ecMobileNo1 == null) {
        this.ecMobileNo1 = ""
      }
      if (this.ecMobileNo2 == null) {
        this.ecMobileNo2 = ""
      }
      if (this.ecMobileNo3 == null) {
        this.ecMobileNo3 = ""
      }
      if (this.ecPhoneNo1 == null) {
        this.ecPhoneNo1 = ""
      }
      if (this.ecPhoneNo2 == null) {
        this.ecPhoneNo2 = ""
      }
      if (this.ecPhoneNo3 == null) {
        this.ecPhoneNo3 = ""
      }
      if (this.ecName == null) {
        this.ecName = ""
      }
      if (this.ecRelations == null) {
        this.ecRelations = ""
      }
      //チェック処理
      //必須項目のいずれが入力されていない場合
      if (this.ecPostCd1 + this.ecPostCd2 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_POSTCODE')), showClose: true })
        return false
      }

      if (this.ecAddress1 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_MSG_ADDRESS1')), showClose: true })
        return false
      }

      //郵便番号桁数チェック
      if (this.ecPostCd1.length != 3 || this.ecPostCd2.length != 4) {
        this.$message.error({ message: this.$t('MODULE.DIALOG_MSG_POST_CODE_CHECK'), showClose: true });
        return false
      }

      //携帯番号と電話番号両方入力していない場合
      if (this.ecMobileNo1 + this.ecMobileNo2 + this.ecMobileNo3 == "" && this.ecPhoneNo1 + this.ecPhoneNo2 + this.ecPhoneNo3 == "") {
        this.$message.error({ message: this.$t('MODULE.I0004_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_CARRYCODE')).replace('{2}', this.$t('MODULE.I0004_LBL_TELCODE')), showClose: true })
        return false
      }

      if (this.ecName == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_CALLNAME')), showClose: true })
        return false
      }

      if (this.ecRelations == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_RELAT')), showClose: true })
        return false
      }

      // データを保存します。よろしいでしょうか？
      // 「はい」を選択したら、下記の処理へ進む
      // 「いいえ」を選択したら、何もしない
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//を選択します
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: true
      }).then(() => {
        //はい
        var update_params = {};
        update_params.ecAddress1 = this.ecAddress1;
        update_params.ecAddress2 = this.ecAddress2;
        update_params.ecAddress3 = this.ecAddress3;
        if (this.ecMobileNo1 + this.ecMobileNo2 + this.ecMobileNo3 == "") {
          update_params.ecMobileNo = "";
        } else {
          update_params.ecMobileNo = this.ecMobileNo1 + "-" + this.ecMobileNo2 + "-" + this.ecMobileNo3;
        }

        if (this.ecPhoneNo1 + this.ecPhoneNo2 + this.ecPhoneNo3 == "") {
          update_params.ecPhoneNo = "";
        } else {
          update_params.ecPhoneNo = this.ecPhoneNo1 + "-" + this.ecPhoneNo2 + "-" + this.ecPhoneNo3;
        }

        update_params.ecName = this.ecName;
        update_params.ecPostCd = this.ecPostCd1 + "-" + this.ecPostCd2;
        update_params.ecRelations = this.ecRelations;
        update_params.processCd = this.processCd;
        update_params.id = this.id;
        if (this.processCd == "2") {
          update_params.updateDate = "";
        } else {
          update_params.updateDate = this.updateDate;
        }
        amsApi.i_0004_update(update_params, this.userCd).then(res => {
          if (res.code === 202) {
            this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
            this.query()
          } else if (res.code === 308) {
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                center: true
              }).then(() => {
                this.query();
              }).catch(() => {
              })
            }, 500)
          } else if (res.code === 311) {
            setTimeout(() => {
              this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
            }, 500)
          }
        });
      }).catch(() => {
        //いいえ
      });
    },
    //住所取得ボタン 按下
    address_click() {
      //将当前郵便番号的值取得,传递到住所Dialog
      if (this.ecPostCd1 == null) {
        this.ecPostCd1 = ""
      }
      if (this.ecPostCd2 == null) {
        this.ecPostCd2 = ""
      }

      if (this.ecPostCd1 + this.ecPostCd2 == "") {
        this.addressPostCode = "";
      } else {
        this.addressPostCode = this.ecPostCd1 + "-" + this.ecPostCd2;
      }

      this.showAddressDialog = true;
    },
    // 选择住所对话框弹窗回调
    submitAddressDialog(row) {
      //住所1:都道府県＋市区町村
      //住所2:大字町丁目＋番地
      console.log(row)
      for (const key in row) {
        if (row[key] == null) {
          row[key] = ""
        }
      }
      this.showAddressDialog = false;
      this.ecAddress1 = row.stateName + row.cityName;
      this.ecAddress2 = row.oazamachiChomName + row.addressBanchi;
      this.ecAddress3 = "";
      // this.ecPostCd1 = row.postCode.split("-")[0];
      // this.ecPostCd2 = row.postCode.split("-")[1];
    },
    // 关闭住所对话框的弹窗回调
    closeAddressDialog() {
      this.showAddressDialog = false;
    },
  }
}
</script>
<style>
/* 表格边框、字体样式 */
.i0004-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0004-table,
.i0004-table tr td {
  border: 1px solid #ccc;
}
.i0004-form-value,
.i0004-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0004-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0004-form-label {
  text-align: right;
  width: 60px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0004-form-value {
  background: #fafafa;
}
/* input框宽度 */
.i0004-input {
  width: 94%;
  font-size: 12px;
}
ul.decimal {
  list-style-type: decimal;
  padding-inline-start: 25px;
}
.i0004-form-value .el-button--small,
.el-button--small.is-round {
  padding-left: 9px;
  padding-right: 9px;
}
/* 按钮样式 */
.i0004-css-btn {
  color: #fff;
  margin-top: 15px;
  width: 20%;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0004-css-btn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0004-css-btn:active,
.i0004-css-btn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
/* 按钮样式 */
.i0004-css-addressbtn {
  color: #fff;
  margin-top: 0px;
  width: 81px;
  height: 100%;
  padding-left: 12px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0004-css-addressbtn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0004-css-addressbtn:active,
.i0004-css-addressbtn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0004.vue